 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCVI from '@/components/OEBPS/cvi'
 import LOVE_1 from '@/components/love_1'
 import OEBPSTP from '@/components/OEBPS/tp'
 import OEBPSCPN from '@/components/OEBPS/cpn'
 import OEBPSDED from '@/components/OEBPS/ded'
 import OEBPSTOC from '@/components/OEBPS/toc'
 import OEBPSFM from '@/components/OEBPS/fm'
 import OEBPSC01 from '@/components/OEBPS/c01'
 import OEBPSC02 from '@/components/OEBPS/c02'
 import OEBPSC03 from '@/components/OEBPS/c03'
 import OEBPSC04 from '@/components/OEBPS/c04'
 import OEBPSC05 from '@/components/OEBPS/c05'
 import OEBPSC06 from '@/components/OEBPS/c06'
 import OEBPSC07 from '@/components/OEBPS/c07'
 import OEBPSC08 from '@/components/OEBPS/c08'
 import OEBPSC09 from '@/components/OEBPS/c09'
 import LOVE_2 from '@/components/love_2'
 import OEBPSACK from '@/components/OEBPS/ack'
 import OEBPSNOTE from '@/components/OEBPS/note'
 import OEBPSBIB from '@/components/OEBPS/bib'
 import OEBPSIND from '@/components/OEBPS/ind'
 import OEBPSPER from '@/components/OEBPS/per'
 import OEBPSCRE from '@/components/OEBPS/cre'
 import OEBPSALS from '@/components/OEBPS/als'
 import OEBPSCOPY from '@/components/OEBPS/copy'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/cvi",
 			"name" : "OEBPS/cvi",
 			"component" : OEBPSCVI
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/OEBPS/tp",
 			"name" : "OEBPS/tp",
 			"component" : OEBPSTP
 		},
 		{
 			"path" : "/OEBPS/cpn",
 			"name" : "OEBPS/cpn",
 			"component" : OEBPSCPN
 		},
 		{
 			"path" : "/OEBPS/ded",
 			"name" : "OEBPS/ded",
 			"component" : OEBPSDED
 		},
 		{
 			"path" : "/OEBPS/toc",
 			"name" : "OEBPS/toc",
 			"component" : OEBPSTOC
 		},
 		{
 			"path" : "/OEBPS/fm",
 			"name" : "OEBPS/fm",
 			"component" : OEBPSFM
 		},
 		{
 			"path" : "/OEBPS/c01",
 			"name" : "OEBPS/c01",
 			"component" : OEBPSC01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js